import { Book, Heart, Search, Info, Phone, FileText, Newspaper } from 'lucide-react';

export const mainNavItems = [
  {
    title: "Baby Names",
    href: "/baby-names",
    icon: Heart,
    description: "Browse Nepali baby names with meanings"
  },
  {
    title: "Name Search",
    href: "/",
    icon: Search,
    description: "Search and explore name meanings"
  },
  {
    title: "Blog",
    href: "/blog",
    icon: Newspaper,
    description: "Articles about names and culture"
  },
  {
    title: "About",
    href: "/about",
    icon: Info,
    description: "Learn about NameExplorer"
  },
  {
    title: "Features",
    href: "/features",
    icon: Book,
    description: "Explore our features"
  },
  {
    title: "Contact",
    href: "/contact",
    icon: Phone,
    description: "Get in touch with us"
  }
];

export const footerNavItems = {
  quickLinks: [
    { title: "Privacy Policy", href: "/privacy" },
    { title: "Terms of Service", href: "/terms" },
    { title: "Contact Us", href: "/contact" }
  ],
  resources: [
    { title: "Blog", href: "/blog" },
    { title: "FAQ", href: "/faq" },
    { title: "Support", href: "/support" }
  ]
};